import {idCardsType} from "./dictionary";

const WeixinStage = {
  WAIT_MAILING_INFORMATION: 'WAIT_MAILING_INFORMATION',
  MAILING_INFORMATION: 'MAILING_INFORMATION',
  INFORMATION_AUTHENTICATION: 'INFORMATION_AUTHENTICATION',
  PAYING: 'PAYING',
  COOLING: 'COOLING',
  RETURN_VISITING: 'RETURN_VISITING',
  SHARE_CONFIRM: 'SHARE_CONFIRM',
  FINISH: 'FINISH',
  APPLICATION_CANCELLATION: 'APPLICATION_CANCELLATION',
  APPLICATION_FAILURE: 'APPLICATION_FAILURE'
}

const ApplyStageStatus = {
  waiting: 'waiting',
  processing: 'processing',
  success: 'success',
  failed: 'failed'
}

const HurdleTypes = {
  HURDLE: 'HURDLE',
  HURDLE_RATE: 'HURDLE_RATE'
}

// 证件类型
export async function idType() {
  return await idCardsType()
}

const UserStatus = {
  INFO: 'info', // 1 填写信息
  INVEST_IDENTITY: 'invest_identity', // 2投资者判断
  RISK: 'risk', // 3风险评估(答题 -> 只有员工才答题)
  RISK_REMIND: 'risk_remind', // 4风险揭示书
  ASSETS: 'assets', // 资产 -> 默认资产
  APPLIES: 'applies', // 资产 -> 申请
  APPOINTS: 'appoints', // 资产 -> 关注
  FORBIDDEN: 'forbidden' // 资产 -> 特别的一种(禁用的状态, 只有一个我的资产)
}

const ApplyTypes = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  ADD: 'ADD',
  REDEMPTION: 'REDEMPTION'
}
/**
 * 产品资讯 ，公告报告pdf 0
 * @type {string}
 */
const FundInformationFileTypePdf = '0';
/**
 * 产品资讯视频 1
 * @type {string}
 */
const FundInformationFileTypeVideo = '1';
/**
 * 产品资讯音频 2
 * @type {string}
 */
const FundInformationFileTypeAudio = '2';

/**
 * 产品资讯音频视频 定时器单位 记录播放进度 15s
 * @type {string}
 */
const FundInformationPlayTimeUnit = '15000';
/**
 * 是 '1'
 * @type {string}
 */
const YES = '1'
/**
 * 否 '0'
 * @type {string}
 */
const NO = '0'
/**
 * todo 保底措施  部分代码 是直接 引用   import { UserStatus } from '@/service/constants.js'
 */
export {WeixinStage, ApplyStageStatus, HurdleTypes, UserStatus, ApplyTypes, FundInformationFileTypePdf, FundInformationFileTypeVideo, FundInformationFileTypeAudio,FundInformationPlayTimeUnit,YES,
  NO}
/**
 * todo 保底措施  部分代码 是直接 引用   import  constants from '@/service/constants.js' const { UserStatus } = constants
 */
export default {
  WeixinStage,
  ApplyStageStatus,
  HurdleTypes,
  UserStatus,
  ApplyTypes,
  FundInformationFileTypePdf,
  FundInformationFileTypeVideo,
  FundInformationFileTypeAudio,
  FundInformationPlayTimeUnit,
  YES,
  NO

}
